/* ============================================================
   Endless Parks — "Mystery Gift / Sticker Pack" Klaviyo popup
   Custom-code popup. Mobile + desktop layouts, 2 steps:
   1) tap your state on the map  2) email capture -> Klaviyo.
   ------------------------------------------------------------
   SETUP (see README.md):
   1. Upload the 4 assets to Shopify (Content > Files) and paste
      their CDN URLs into CONFIG.assets below.
   2. Paste your Klaviyo Public API Key (Site ID) + List ID.
   3. Include this file before </body> in theme.liquid:
      <script src="{{ 'endless-parks-popup.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  'use strict';

  var DEFAULTS = {
    companyId: 'YOUR_PUBLIC_API_KEY',   // Klaviyo Account > Settings > API keys ("Site ID" / public key, 6 chars)
    listId: 'YOUR_LIST_ID',             // Klaviyo list settings (6 chars)
    delayMs: 8000,                      // 8 second time delay
    resurfaceDays: 30,                  // don't re-show for N days after dismissal
    statePropertyName: 'State',         // Klaviyo profile property to store the tapped state
    customSource: 'Sticker Pack Popup',
    assets: {
      logo: 'ASSET_URL/Logo_Endless_Parks_Outback_Rust.png',
      rocaFont: 'ASSET_URL/Roca-Black.ttf',
      map: 'ASSET_URL/australia-all-states.svg',
      // Reveal photo per state. Fill in what you have; 'default' is the fallback.
      photos: {
        default: '',
        WA: '', NT: '', SA: '', QLD: '', NSW: '', VIC: '', TAS: '', ACT: '',
        traveller: ''
      },
      // Optional lifestyle photo at the bottom of the mobile step-1 screen
      mobileHero: '',
      // Full-screen background photo for the mobile step-2 screen
      step2Bg: '',
      // Higher-res background for the desktop step-2 screen (falls back to step2Bg)
      step2BgDesktop: ''
    },
    // Step 1 style: 'map' (tap-your-state) or 'pills' (choice buttons).
    step1Mode: 'map',
    question: 'What state are you from?',
    pills: ['Adventure Bottles', 'State Mugs', 'Other'],
    // A/B testing: set enabled:true and put config overrides in variants.A / variants.B.
    // Each visitor is randomly assigned once (persisted) and their variant is stamped on
    // Clarity events and the Klaviyo profile ("Popup Variant") for comparison.
    abTest: {
      enabled: false,
      variants: { A: {}, B: {} }
    }
  };

  var CONFIG = merge(DEFAULTS, window.EndlessParksPopupConfig || {});

  /* ---------- A/B variant assignment ---------- */
  var AB_VARIANT = 'A';
  try {
    /* QA hook: localStorage.ep_popup_force_variant = 'A'|'B' previews a variant even while the test is disabled */
    var _force = localStorage.getItem('ep_popup_force_variant');
    if (_force === 'A' || _force === 'B') {
      AB_VARIANT = _force;
      var _fov = ((CONFIG.abTest || {}).variants || {})[AB_VARIANT];
      if (_fov) CONFIG = merge(CONFIG, _fov);
    } else if (CONFIG.abTest && CONFIG.abTest.enabled) {
      var _v = localStorage.getItem('ep_popup_variant');
      if (_v !== 'A' && _v !== 'B') {
        _v = Math.random() < 0.5 ? 'A' : 'B';
        localStorage.setItem('ep_popup_variant', _v);
      }
      AB_VARIANT = _v;
      var _ov = (CONFIG.abTest.variants || {})[AB_VARIANT];
      if (_ov) CONFIG = merge(CONFIG, _ov);
    }
  } catch (e) {}

  /* ---------- funnel tracking (Microsoft Clarity) ---------- */
  function track(name, state) {
    try {
      if (typeof window.clarity !== 'function') return;
      window.clarity('set', 'ep_popup_variant', AB_VARIANT);
      if (state) window.clarity('set', 'ep_popup_state', state);
      window.clarity('event', 'ep_popup_' + name);
    } catch (e) {}
  }

  var TEST_MODE = /YOUR_/.test(CONFIG.companyId) || /YOUR_/.test(CONFIG.listId);

  var LS_DONE = 'ep_popup_subscribed';
  var LS_DISMISSED = 'ep_popup_dismissed_at';

  var CREAM = '#FBF3E3', ORANGE = '#cb6015', DEEP = '#A9500F',
      INK = '#3a2a1a', MUTED = '#a99883', SWASH = '#FFC87B';

  var MAP_LABELS = [
    { t: 'WA', x: 294, y: 628 }, { t: 'NT', x: 702, y: 430 },
    { t: 'SA', x: 760, y: 778 }, { t: 'QLD', x: 1062, y: 505 },
    { t: 'NSW', x: 1150, y: 890 }, { t: 'VIC', x: 1080, y: 1110 },
    { t: 'TAS', x: 1159, y: 1269 }, { t: 'ACT', x: 1236, y: 1011 },
    { t: 'OTHER', x: 539, y: 1074 }
  ];

  // Hand-drawn shapes (baked from the approved design)
  var SHAPE_PANEL = 'M 42 10 C 170 2, 320 14, 420 7 Q 452 5, 450 34 C 444 190, 456 380, 449 548 Q 450 574, 420 572 C 300 580, 150 570, 40 575 Q 12 577, 13 548 C 6 400, 18 190, 9 36 Q 7 10, 42 10 Z';
  var FRAME_RECT = 'M 36 9 C 130 3, 270 13, 358 7 Q 388 5, 386 33 C 381 105, 391 195, 387 268 Q 388 295, 358 293 C 268 301, 128 293, 38 297 Q 10 299, 11 271 C 5 198, 15 108, 8 35 Q 7 10, 36 9 Z';
  var FRAME_SQUARE = 'M 34 9 C 100 3, 210 13, 268 7 Q 296 5, 294 33 C 289 105, 299 195, 295 268 Q 296 295, 268 293 C 205 301, 98 293, 36 297 Q 10 299, 11 271 C 5 198, 15 108, 8 35 Q 7 10, 34 9 Z';
  var SWASH_PATH = 'M6 13 C 60 9, 140 9, 194 12';
  var PANEL_TOP_MOBILE = 'M0 10 C 110 2, 320 14, 430 5 L430 20 L0 20 Z';
  // "Worth up to" arc (curve 66) + rotation -21deg
  var WORTH_PATH = 'M5 48 Q 175 -18, 345 48';
  var WORTH_ROTATE = -21;

  // Sun rays around $29 (count 5, spread 150deg, curve 2, length 24, distance 65)
  function sunRays() {
    var n = 5, spread = 150 * Math.PI / 180, curve = 2, len = 24, r1 = 65, cx = 110, cy = 84;
    var out = [];
    for (var i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (-spread / 2 + spread * i / (n - 1));
      var x1 = cx + r1 * Math.cos(a), y1 = cy + r1 * Math.sin(a);
      var x2 = cx + (r1 + len) * Math.cos(a), y2 = cy + (r1 + len) * Math.sin(a);
      var mx = (x1 + x2) / 2 - Math.sin(a) * curve, my = (y1 + y2) / 2 + Math.cos(a) * curve;
      out.push('M' + r1d(x1) + ' ' + r1d(y1) + ' Q ' + r1d(mx) + ' ' + r1d(my) + ', ' + r1d(x2) + ' ' + r1d(y2));
    }
    return out;
  }
  function r1d(v) { return Math.round(v * 10) / 10; }

  function merge(base, over) {
    var out = {};
    Object.keys(base).forEach(function (k) {
      if (base[k] && typeof base[k] === 'object' && !Array.isArray(base[k])) {
        out[k] = merge(base[k], (over && over[k]) || {});
      } else {
        out[k] = over && over[k] !== undefined ? over[k] : base[k];
      }
    });
    if (over) Object.keys(over).forEach(function (k) { if (!(k in out)) out[k] = over[k]; });
    return out;
  }

  /* ---------- gating ---------- */
  function shouldShow() {
    try {
      if (localStorage.getItem(LS_DONE)) return false;
      var d = parseInt(localStorage.getItem(LS_DISMISSED) || '0', 10);
      if (d && (Date.now() - d) < CONFIG.resurfaceDays * 864e5) return false;
    } catch (e) {}
    return true;
  }

  /* ---------- styles ---------- */
  function css() {
    return '' +
    '@font-face{font-family:"EP Roca";src:url("' + CONFIG.assets.rocaFont + '") format("truetype");font-weight:400 900;font-display:swap;}' +
    '.ep-pop{position:fixed;inset:0;z-index:2147483000;background:' + CREAM + ';font-family:"Nunito Sans",sans-serif;opacity:0;transition:opacity .35s ease;overflow:auto;}' +
    '.ep-pop.ep-in{opacity:1;}' +
    '.ep-roca{font-family:"EP Roca","Fredoka",sans-serif;}' +
    '.ep-x{position:absolute;top:16px;right:16px;width:38px;height:38px;border-radius:50%;border:none;background:rgba(58,42,26,.08);color:' + INK + ';font-size:19px;cursor:pointer;z-index:9;line-height:1;}' +
    '.ep-x:hover{background:rgba(58,42,26,.16);}' +
    '.ep-back{position:absolute;top:16px;left:16px;width:38px;height:38px;border-radius:50%;border:none;background:rgba(251,243,227,.85);color:' + INK + ';font-size:19px;cursor:pointer;z-index:9;line-height:1;}' +
    '.ep-back:hover{background:rgba(251,243,227,1);}' +
    '.ep-map svg{width:100%;height:100%;display:block;}' +
    '.ep-map path{cursor:pointer;transition:opacity .15s;}' +
    '.ep-map path:hover{opacity:.65;}' +
    '.ep-map [data-state]{cursor:pointer;}' +
    '.ep-input{width:100%;box-sizing:border-box;padding:15px 16px;border-radius:14px;font-size:15px;font-family:"Nunito Sans",sans-serif;outline:none;text-align:center;border:1.5px solid #e3d3b8;background:#fff;color:' + INK + ';}' +
    '.ep-btn{width:100%;padding:15px 16px;border-radius:14px;border:none;font-weight:600;font-size:16px;cursor:pointer;font-family:"EP Roca","Fredoka",sans-serif;}' +
    '.ep-skip{background:none;border:none;font-family:"Nunito Sans",sans-serif;font-weight:700;font-size:13px;cursor:pointer;}' +
    '.ep-err{display:none;font-size:12.5px;color:#b3261e;margin:6px 0 0;}' +
    '.ep-pills{display:flex;flex-direction:column;gap:11px;width:100%;max-width:270px;margin-left:auto;margin-right:auto;}' +
    '.ep-pill{font-family:"EP Roca","Fredoka",sans-serif;font-weight:600;font-size:15px;color:' + ORANGE + ';background:#fff;border:2px solid ' + ORANGE + ';border-radius:999px;padding:11px 16px;cursor:pointer;transition:transform .12s ease, box-shadow .12s ease;box-shadow:0 4px 12px -6px rgba(58,42,26,.25);}' +
    '.ep-pill:hover{transform:translateY(-2px);box-shadow:0 8px 18px -8px rgba(58,42,26,.35);}' +
    '.ep-teaser{position:fixed;bottom:18px;left:18px;z-index:2147482900;display:flex;align-items:center;gap:8px;background:#203568;color:' + CREAM + ';border:none;cursor:pointer;font-family:"EP Roca","Fredoka",sans-serif;font-weight:600;font-size:15px;padding:12px 20px;border-radius:999px;box-shadow:0 10px 24px -8px rgba(58,42,26,.45);transition:transform .15s ease, box-shadow .15s ease;}' +
    '.ep-teaser:hover{transform:translateY(-2px);box-shadow:0 14px 28px -8px rgba(58,42,26,.5);}' +
    /* keep the teaser out of the way of bundle option modals and the cart drawer */
    'html.cb-modal-open .ep-teaser,html.epm-modal-open .ep-teaser,html.campfire-cart-open .ep-teaser{display:none;}' +
    /* EP 2 Nov 2026: sit above the mobile sticky Add to Cart bar instead of covering it */
    'body:has(.ep-sticky-atc.is-visible) .ep-teaser{bottom:calc(86px + env(safe-area-inset-bottom, 0px));}' +
    '.ep-desktop{display:none;}' +
    '@media(min-width:769px){.ep-desktop{display:flex;}.ep-mobile{display:none;}}' +
    '@media(max-width:768px){.ep-desktop{display:none;}.ep-mobile{display:flex;}}';
  }

  /* ---------- shared pieces ---------- */
  function swashEyebrow(fontSize, lh) {
    return '<div class="ep-roca" style="font-weight:700;font-size:' + fontSize + 'px;color:' + ORANGE + ';letter-spacing:.06em;line-height:' + lh + ';">' +
      '<span style="display:block;">YOU\'VE GOT</span>' +
      '<span style="position:relative;display:inline-block;white-space:nowrap;font-size:1.5em;line-height:1.1;">' +
        '<svg aria-hidden="true" viewBox="0 0 200 24" preserveAspectRatio="none" style="position:absolute;left:-5%;top:50%;width:110%;height:.85em;transform:translateY(-46%);z-index:0;overflow:visible;"><path d="' + SWASH_PATH + '" fill="none" stroke="' + SWASH + '" stroke-width="16" stroke-linecap="round"></path></svg>' +
        '<span style="position:relative;">10% OFF</span>' +
      '</span></div>';
  }

  function raysSvg(left, top, color) {
    return '<svg aria-hidden="true" viewBox="0 0 220 140" style="position:absolute;left:' + left + 'px;top:' + top + 'px;width:220px;height:140px;overflow:visible;pointer-events:none;"><g fill="none" stroke="' + color + '" stroke-width="6" stroke-linecap="round">' +
      sunRays().map(function (d) { return '<path d="' + d + '"></path>'; }).join('') +
      '</g></svg>';
  }

  function photoUrl(state) {
    var p = CONFIG.assets.photos || {};
    return p[state] || p.default || '';
  }

  function photoBlock(state, w, h, clip) {
    var url = photoUrl(state);
    var inner = url
      ? '<img src="' + url + '" alt="Sticker pack" style="width:100%;height:100%;object-fit:cover;display:block;' + (clip ? 'clip-path:inset(0 4% 0 4%);' : '') + '">'
      : '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:rgba(58,42,26,.07);border-radius:12px;color:' + MUTED + ';font-size:13px;">Sticker pack photo</div>';
    return '<div style="width:' + w + ';height:' + h + ';position:relative;">' + inner + '</div>';
  }

  function pillsHtml(topMargin) {
    var out = '<div class="ep-pills" data-ep-pills style="margin-top:' + (topMargin || 0) + 'px;">';
    (CONFIG.pills || []).forEach(function (label) {
      out += '<button type="button" class="ep-pill" data-ep-pill="' + label + '">' + label + '</button>';
    });
    return out + '</div>';
  }

  /* ---------- desktop (920x580 panel, full-page cream) ---------- */
  function desktopHtml() {
    return '' +
    '<div class="ep-desktop" style="width:100%;min-height:100%;align-items:center;justify-content:center;">' +
      '<div style="position:relative;width:920px;max-width:96vw;height:580px;display:flex;" data-ep-panel>' +

        /* step 1 */
        '<div data-ep-step="1" style="display:flex;width:100%;">' +
          '<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:44px 26px;text-align:center;">' +
            '<img src="' + CONFIG.assets.logo + '" alt="Endless Parks" style="height:' + (CONFIG.step1Mode === 'pills' ? '78' : '98') + 'px;display:block;align-self:center;margin-bottom:10px;">' +
            swashEyebrow(CONFIG.step1Mode === 'pills' ? 38 : 30, 1.15) +
            (CONFIG.step1Mode === 'pills' ? '' : '<div class="ep-roca" style="font-weight:600;font-size:min(27px, 2.75vw);color:' + INK + ';line-height:1.12;white-space:nowrap;">' + CONFIG.question + '</div>' +
            '<div style="font-size:13px;color:' + MUTED + ';">Click your state on the map to unlock</div>') +
          '</div>' +
          (CONFIG.step1Mode === 'pills'
            ? '<div style="flex:1.1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;">' + '<div class="ep-roca" style="font-weight:600;font-size:min(27px, 2.75vw);color:' + INK + ';line-height:1.12;white-space:nowrap;">' + CONFIG.question + '</div>' + pillsHtml(0) + '</div>'
            : '<div style="flex:1.1;position:relative;">' +
              '<div class="ep-map" data-ep-map style="position:absolute;left:-16px;top:89px;width:537px;height:443px;max-width:100%;color:' + ORANGE + ';cursor:pointer;"></div>' +
            '</div>') +
        '</div>' +

        /* step 2 */
        '<div data-ep-step="2" style="display:none;position:fixed;inset:0;background-image:url(' + (CONFIG.assets.step2BgDesktop || CONFIG.assets.step2Bg || '') + ');background-size:cover;background-position:center;">' +
          '<button type="button" class="ep-back" data-ep-back aria-label="Back to state selection">&#8592;</button>' +
          '<div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:40px;background:linear-gradient(180deg, rgba(58,42,26,.15) 0%, rgba(58,42,26,.4) 55%, rgba(58,42,26,.55) 100%);">' +
            '<div class="ep-roca" style="font-weight:600;font-size:34px;color:' + CREAM + ';margin-bottom:8px;">You get 10% off</div>' +
            '<div style="font-size:14.5px;color:rgba(251,243,227,.9);margin-bottom:20px;">Pop your email in and we\'ll send your discount code your way.</div>' +
            '<form data-ep-form novalidate style="width:100%;max-width:370px;">' +
              '<input class="ep-input" type="email" name="email" required placeholder="you@email.com" autocomplete="email" style="border:none;margin-bottom:12px;">' +
              '<button class="ep-btn" type="submit" style="background:' + CREAM + ';color:' + ORANGE + ';">Claim my 10% off</button>' +
              '<div class="ep-err" data-ep-err style="color:#ffd9cf;"></div>' +
            '</form>' +
            '<div style="margin-top:14px;font-size:12px;color:rgba(251,243,227,.8);">No spam — just your discount and our awesome community!</div>' +
            '<button class="ep-skip" data-ep-close style="margin-top:8px;color:rgba(251,243,227,.8);">No thanks</button>' +
          '</div>' +
        '</div>' +

        /* step 3: success */
        '<div data-ep-step="3" style="display:none;width:100%;align-items:center;justify-content:center;">' +
          '<div style="text-align:center;max-width:480px;padding:40px;">' +
            '<img src="' + CONFIG.assets.logo + '" alt="Endless Parks" style="height:86px;display:block;margin:0 auto 22px;">' +
            '<div class="ep-roca" style="font-weight:600;font-size:32px;color:' + ORANGE + ';line-height:1.2;margin-bottom:10px;">You\'re in!</div>' +
            '<div style="font-size:15px;color:' + INK + ';">Check your inbox — your discount code is on its way.</div>' +
          '</div>' +
        '</div>' +

      '</div>' +
    '</div>';
  }

  /* ---------- mobile (full screen) ---------- */
  function mobileHtml() {
    var hero = CONFIG.assets.mobileHero
      ? '<div style="width:calc(100% + 44px);height:208px;margin:10px -22px 0;' + (CONFIG.step1Mode === 'pills' ? 'margin-top:auto;' : '') + '"><img src="' + CONFIG.assets.mobileHero + '" alt="" style="width:100%;height:100%;object-fit:cover;object-position:50% 0%;display:block;"></div>'
      : '';
    return '' +
    '<div class="ep-mobile" style="width:100%;min-height:100%;flex-direction:column;">' +

      /* step 1 */
      '<div data-ep-step="1" style="display:flex;flex-direction:column;flex:1;min-height:100dvh;padding-top:20px;">' +
        '<div style="display:flex;align-items:flex-start;justify-content:center;padding:10px 20px 0;">' +
          '<img src="' + CONFIG.assets.logo + '" alt="Endless Parks" style="height:68px;display:block;">' +
        '</div>' +
        '<div style="flex:1;display:flex;flex-direction:column;padding:8px 22px 0;text-align:center;">' +
          '<div style="margin-top:24px;">' + swashEyebrow(35, 1.1) + '</div>' +
          '<div class="ep-roca" style="font-weight:600;font-size:min(22px, calc(6.6vw - 2.9px));color:' + INK + ';line-height:1.12;margin-top:4px;white-space:nowrap;">' + CONFIG.question + '</div>' +
          (CONFIG.step1Mode === 'pills'
            ? pillsHtml(14)
            : '<div class="ep-map" data-ep-map style="width:100%;height:330px;color:' + ORANGE + ';margin-top:4px;cursor:pointer;"></div>' +
              '<div style="font-size:12px;color:' + MUTED + ';margin-top:2px;">Tap your state on the map to unlock</div>') +
          hero +
        '</div>' +
      '</div>' +

      /* step 2 */
      '<div data-ep-step="2" style="display:none;position:relative;flex-direction:column;flex:1;min-height:100dvh;background-image:url(' + (CONFIG.assets.step2Bg || '') + ');background-size:auto 112%;background-position:50% 0;background-repeat:no-repeat;">' +
        '<button type="button" class="ep-back" data-ep-back aria-label="Back to state selection">&#8592;</button>' +
        '<div data-ep-photo-mobile style="display:none;"></div>' +
        '<div style="position:relative;flex:1;display:flex;flex-direction:column;justify-content:center;padding:34px 26px 130px;text-align:center;background:linear-gradient(180deg, rgba(58,42,26,.18) 0%, rgba(58,42,26,.45) 45%, rgba(58,42,26,.6) 100%);">' +
          '<div class="ep-roca" style="font-weight:600;font-size:27px;color:' + CREAM + ';margin-bottom:8px;">You get 10% off</div>' +
          '<div style="font-size:15px;color:rgba(251,243,227,.85);margin-bottom:20px;">Pop your email in and we\'ll send your discount code your way.</div>' +
          '<form data-ep-form novalidate>' +
            '<input class="ep-input" type="email" name="email" required placeholder="you@email.com" autocomplete="email" style="border:none;margin-bottom:10px;padding:12px 14px;font-size:14px;">' +
            '<button class="ep-btn" type="submit" style="background:' + CREAM + ';color:' + ORANGE + ';padding:12px 14px;font-size:15px;">Claim my 10% off</button>' +
            '<div class="ep-err" data-ep-err style="color:#ffd9cf;"></div>' +
          '</form>' +
          '<div style="margin-top:12px;font-size:12.5px;color:rgba(251,243,227,.75);">No spam — just your discount and our awesome community!</div>' +
          '<button class="ep-skip" data-ep-close style="margin-top:8px;color:rgba(251,243,227,.75);align-self:center;">No thanks</button>' +
        '</div>' +
      '</div>' +

      /* step 3: success */
      '<div data-ep-step="3" style="display:none;flex-direction:column;flex:1;min-height:100dvh;align-items:center;justify-content:center;padding:40px 30px;text-align:center;">' +
        '<img src="' + CONFIG.assets.logo + '" alt="Endless Parks" style="height:76px;display:block;margin-bottom:20px;">' +
        '<div class="ep-roca" style="font-weight:600;font-size:30px;color:' + ORANGE + ';line-height:1.2;margin-bottom:10px;">You\'re in!</div>' +
        '<div style="font-size:15px;color:' + INK + ';">Check your inbox — your discount code is on its way.</div>' +
      '</div>' +

    '</div>';
  }

  /* ---------- map ---------- */
  function buildMapLabels() {
    return MAP_LABELS.map(function (l) {
      var big = l.t === 'OTHER';
      var fs = big ? 66 : 50;
      var w = (big ? 74 : 56) + l.t.length * (big ? 42 : 44);
      var h = big ? 112 : 86;
      return '<g data-state="' + l.t + '">' +
        '<rect x="' + (l.x - w / 2) + '" y="' + (l.y - h / 2) + '" width="' + w + '" height="' + h + '" rx="' + (big ? 32 : 24) + '" fill="#fff"/>' +
        '<text x="' + l.x + '" y="' + (l.y + (big ? 24 : 18)) + '" text-anchor="middle" font-family="Nunito Sans, sans-serif" font-size="' + fs + '" font-weight="800" fill="' + ORANGE + '">' + l.t + '</text>' +
        '</g>';
    }).join('');
  }

  function loadMap(cb) {
    fetch(CONFIG.assets.map)
      .then(function (r) { return r.text(); })
      .then(function (svg) { cb(svg.replace('</svg>', buildMapLabels() + '</svg>')); })
      .catch(function () { cb(null); });
  }

  /* ---------- frames on the desktop photo ---------- */
  function frameFor(state) {
    if (state === 'QLD') {
      return '<svg viewBox="0 0 303 303" style="position:absolute;left:-3px;top:-20px;width:398px;height:314px;overflow:visible;pointer-events:none;"><path d="' + FRAME_SQUARE + '" fill="none" stroke="' + DEEP + '" stroke-width="15" stroke-linejoin="round"></path></svg>';
    }
    return '<svg viewBox="0 0 396 303" style="position:absolute;left:-4px;top:4px;width:388px;height:279px;overflow:visible;pointer-events:none;"><path d="' + FRAME_RECT + '" fill="none" stroke="' + DEEP + '" stroke-width="15" stroke-linejoin="round"></path></svg>';
  }

  /* ---------- Klaviyo submit ---------- */
  function subscribe(email, state) {
    if (TEST_MODE) {
      console.log('[EP popup TEST MODE] would subscribe:', email, '| ' + CONFIG.statePropertyName + ':', state);
      return Promise.resolve();
    }
    var props = {};
    props[CONFIG.statePropertyName] = state;
    props['Popup Variant'] = AB_VARIANT;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CONFIG.customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: props }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: CONFIG.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CONFIG.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo responded ' + r.status);
    });
  }

  /* ---------- shared styles + teaser ---------- */
  var stylesDone = false;
  function ensureStyles() {
    if (stylesDone) return;
    stylesDone = true;
    var style = document.createElement('style');
    style.textContent = css();
    document.head.appendChild(style);
    var fonts = document.createElement('link');
    fonts.rel = 'stylesheet';
    fonts.href = 'https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600;700&family=Nunito+Sans:wght@400;600;700;800&display=swap';
    document.head.appendChild(fonts);
  }

  var teaserEl = null;
  function showTeaser() {
    try { if (localStorage.getItem(LS_DONE)) return; } catch (e) {}
    if (teaserEl) return;
    ensureStyles();
    teaserEl = document.createElement('button');
    teaserEl.type = 'button';
    teaserEl.className = 'ep-teaser';
    teaserEl.setAttribute('aria-label', 'Open the 10% off signup');
    teaserEl.innerHTML = 'Psst\u2026 10% off';
    teaserEl.addEventListener('click', function () { track('teaser_clicked'); hideTeaser(); open(); });
    document.body.appendChild(teaserEl);
  }
  function hideTeaser() {
    if (teaserEl) { teaserEl.remove(); teaserEl = null; }
  }

  /* ---------- controller ---------- */
  function open() {
    ensureStyles();
    hideTeaser();
    track('viewed');
    /* Preload the step-2 background so it's cached before the visitor gets there */
    try {
      if (!window._epBgPreloaded) {
        window._epBgPreloaded = true;
        var _bg = window.matchMedia('(min-width: 769px)').matches
          ? (CONFIG.assets.step2BgDesktop || CONFIG.assets.step2Bg)
          : CONFIG.assets.step2Bg;
        if (_bg) { var _pre = new Image(); _pre.src = _bg; }
      }
    } catch (e) {}

    var root = document.createElement('div');
    root.className = 'ep-pop';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', '10% off offer');
    root.innerHTML = '<button class="ep-x" data-ep-close aria-label="Close">&times;</button>' + desktopHtml() + mobileHtml();
    document.body.appendChild(root);
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    void root.offsetWidth; // force reflow so the fade-in transition runs
    root.classList.add('ep-in');

    var chosenState = '';

    function close(dismissed) {
      root.classList.remove('ep-in');
      setTimeout(function () {
        root.remove();
        document.body.style.overflow = prevOverflow;
      }, 350);
      if (dismissed) {
        try { localStorage.setItem(LS_DISMISSED, String(Date.now())); } catch (e) {}
        track('dismissed');
        showTeaser();
      }
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) { if (e.key === 'Escape') close(true); }
    document.addEventListener('keydown', onKey);

    root.querySelectorAll('[data-ep-close]').forEach(function (b) {
      b.addEventListener('click', function () { close(true); });
    });

    function goStep(n) {
      root.querySelectorAll('[data-ep-step]').forEach(function (el) {
        el.style.display = el.getAttribute('data-ep-step') === String(n) ? 'flex' : 'none';
      });
    }
    root.querySelectorAll('[data-ep-back]').forEach(function (b) {
      b.addEventListener('click', function () { goStep(1); });
    });

    /* pills (variant) */
    root.querySelectorAll('[data-ep-pill]').forEach(function (b) {
      b.addEventListener('click', function () {
        chosenState = b.getAttribute('data-ep-pill');
        track('state_tapped', chosenState);
        root.querySelectorAll('[data-ep-state-name]').forEach(function (n) { n.textContent = chosenState; });
        goStep(2);
      });
    });

    /* map */
    if (CONFIG.step1Mode !== 'pills') loadMap(function (svg) {
      root.querySelectorAll('[data-ep-map]').forEach(function (el) {
        if (svg) el.innerHTML = svg;
        el.addEventListener('click', function (e) {
          var g = e.target.closest('[data-state]');
          var label = g ? g.getAttribute('data-state') : null;
          if (!label) {
            var p = e.target.closest('path[id]');
            if (p) label = p.id.toUpperCase();
          }
          if (!label) return;
          chosenState = label === 'OTHER' ? 'traveller' : label;
          track('state_tapped', chosenState);
          /* fill state name + photos */
          root.querySelectorAll('[data-ep-state-name]').forEach(function (s) { s.textContent = chosenState; });
          var d = root.querySelector('[data-ep-photo-desktop]');
          if (d) d.innerHTML = photoBlock(chosenState, '100%', '100%', true) + frameFor(chosenState);
          var m = root.querySelector('[data-ep-photo-mobile]');
          if (m) m.innerHTML = photoBlock(chosenState, '100%', '100%', false);
          goStep(2);
        });
      });
    });

    /* forms */
    root.querySelectorAll('[data-ep-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type=email]');
        var err = form.querySelector('[data-ep-err]');
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          err.textContent = 'Please enter a valid email address.';
          err.style.display = 'block';
          return;
        }
        err.style.display = 'none';
        var btn = form.querySelector('button[type=submit]');
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Sending…';
        subscribe(email, chosenState).then(function () {
          try { localStorage.setItem(LS_DONE, '1'); } catch (e2) {}
          track('submitted', chosenState);
          goStep(3);
          setTimeout(function () { close(false); }, 3500);
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = orig;
          err.textContent = 'Something went wrong — please try again.';
          err.style.display = 'block';
        });
      });
    });
  }

  /* EP 2 Nov 2026: Google rates the ad landing pages "Below average" partly because
     this full-screen popup covers the page. Visitors from Google Ads (for the whole
     visit, plus Google's AdsBot) now get the small teaser instead; tapping it still
     opens the full signup. Showing the teaser to ALL mobile visitors was considered
     and held: it would likely cut popup signups by about half (see setup log). */
  var SS_AD = 'ep_ad_visit';
  function isAdVisit() {
    try { if (sessionStorage.getItem(SS_AD)) return true; } catch (e) {}
    var ad = false;
    try {
      var q = new URLSearchParams(window.location.search);
      var src = (q.get('utm_source') || '').toLowerCase();
      var med = (q.get('utm_medium') || '').toLowerCase();
      ad = q.has('gclid') || q.has('gbraid') || q.has('wbraid') || q.has('gad_source') ||
        /AdsBot-Google/i.test(navigator.userAgent || '') ||
        (q.get('tw_source') || '').toLowerCase() === 'google' ||
        (src === 'google' && (med === 'cpc' || med === 'ppc' || med === 'paid'));
    } catch (e) {}
    if (ad) { try { sessionStorage.setItem(SS_AD, '1'); } catch (e) {} }
    return ad;
  }
  function init() {
    try { if (localStorage.getItem(LS_DONE)) return; } catch (e) {}
    if (!shouldShow()) { showTeaser(); return; }
    if (isAdVisit()) {
      setTimeout(function () { track('teaser_auto'); showTeaser(); }, CONFIG.delayMs);
      return;
    }
    setTimeout(open, CONFIG.delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
